export default __webpack_public_path__ + "ea5e156ff7f792388da40fe139821ba7.png";